export const sortByStringProperty = (array, propertyName) =>
  array.sort(sortByStringPropertyAlgorithm(propertyName));

export const sortByStringPropertyAlgorithm = propertyName => (a, b) =>
  a[propertyName].toLowerCase() > b[propertyName].toLowerCase() ? 1 : -1;

export const sortByDateProperty = (array, propertyName) =>
  array.sort((a, b) => new Date(b[propertyName]) - new Date(a[propertyName]));
